import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pp-ticket-check-results-detail__subheading" }

import { ref } from "vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import PpDrawNumbers from "@/lotteries/product-page/components/results/pp-draw-numbers.vue";
import { showAlert } from "@sazka/design-system/src/modal-alert/mount-alert";
import { DrawResults } from "@/lotteries/services/model/draw-results";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { fetchResultsById } from "@/lotteries/services/draw-info/api";
import { DateTimeUtils } from "@sazka/utils/date-time-utils";
import PpDrawNumbersRychla6 from "../results/pp-draw-numbers-rychla-6.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-ticket-check-results-draw-detail',
  props: {
    lottery: {},
    drawId: {}
  },
  setup(__props: any) {

const props = __props;

let drawResults: DrawResults = null;
let drawDateText: string = null;
const isDetailOpen = ref(false);

async function loadDetailedResults() {
    try {
        drawResults = await fetchResultsById(props.lottery, props.drawId);
        drawDateText = `Slosováno 
            ${DateTimeUtils.formatLongDateWithWeekday(new Date(drawResults.drawDate))},
            ${drawResults.week}. týden`;

        isDetailOpen.value = true;
    } catch {
        showAlert({ title: "Nepodařilo se načíst podrobné výsledky" });
        return;
    }
}

return (_ctx: any,_cache: any) => {
  return (!isDetailOpen.value)
    ? (_openBlock(), _createBlock(DsButton, {
        key: 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (loadDetailedResults())),
        class: "pp-ticket-check-results-detail__draw-detail"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("NAČÍST PODROBNÉ VÝSLEDKY")
        ])),
        _: 1,
        __: [1]
      }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createElementVNode("h4", _hoisted_1, _toDisplayString(_unref(drawDateText)), 1),
        (_ctx.lottery === _unref(Lottery).rychla6)
          ? (_openBlock(), _createBlock(PpDrawNumbersRychla6, {
              key: 0,
              class: "pp-ticket-check-results-detail__draw-detail",
              numbers: _unref(drawResults).numbers
            }, null, 8, ["numbers"]))
          : (_openBlock(), _createBlock(PpDrawNumbers, {
              key: 1,
              lottery: _ctx.lottery,
              numbers: _unref(drawResults).numbers,
              "sort-by-draw": true,
              class: "pp-ticket-check-results-detail__draw-detail"
            }, null, 8, ["lottery", "numbers"]))
      ], 64))
}
}

})